import { datadogRum } from '@datadog/browser-rum';

import { BlenderContext, TokiContext } from '../types/context';

export const setGlobalContext = (context: TokiContext | BlenderContext) => {
  datadogRum.setGlobalContext(context);
};
